import { Modal, Form } from "react-bootstrap";
import ErrorAlert from "../../../common/ui/ErrorAlert";

export default function WardModal(props) {
    return (
        <>
            <Modal show={props.wardDetails.WardModal.ModalIsShown} backdrop="static" keyboard={false}>
                <div className="modal-header">
                    <h1 className="modal-title fs-5">Ward Details</h1>
                </div>
                <Modal.Body>
                    <div className="row gy-3">
                        <div className="col-12">
                            <Form.Floating>
                                <Form.Control type="text" id="txtFloorNumber" name="floornumber" value={props.wardDetails.WardModalFields.floornumber.Value} className={props.wardDetails.WardModalFields.floornumber.HasError ? "is-invalid" : ""} onChange={props.handleChangeWardModalFields} />
                                <label htmlFor="txtFloorNumber">Floor</label>
                                <Form.Control.Feedback type="invalid">{props.wardDetails.WardModalFields.floornumber.ErrorMessage}</Form.Control.Feedback>
                            </Form.Floating>
                        </div>
                        <div className="col-12">
                            <Form.Floating>
                                <Form.Control type="text" id="txtWardNumber" name="wardnumber" value={props.wardDetails.WardModalFields.wardnumber.Value} className={props.wardDetails.WardModalFields.wardnumber.HasError ? "is-invalid" : ""} onChange={props.handleChangeWardModalFields} />
                                <label htmlFor="txtWardNumber">Ward</label>
                                <Form.Control.Feedback type="invalid">{props.wardDetails.WardModalFields.wardnumber.ErrorMessage}</Form.Control.Feedback>
                            </Form.Floating>
                        </div>
                        <div className="col-12">
                            <Form.Floating>
                                <Form.Control type="text" id="txtBedNumber" name="bednumber" value={props.wardDetails.WardModalFields.bednumber.Value} className={props.wardDetails.WardModalFields.bednumber.HasError ? "is-invalid" : ""} onChange={props.handleChangeWardModalFields} />
                                <label htmlFor="txtBedNumber">Bed</label>
                                <Form.Control.Feedback type="invalid">{props.wardDetails.WardModalFields.bednumber.ErrorMessage}</Form.Control.Feedback>
                            </Form.Floating>
                        </div>
                        {props.wardDetails.WardModalError.HasError && 
                            <div className="col-12">
                                <ErrorAlert message={props.wardDetails.WardModalError.ErrorMessage} />
                            </div>
                        }
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <div className="col-12 d-flex justify-content-center mx-auto">
                        <button type="button" className="btn btn-dark rounded-pill px-5"  disabled={props.wardDetails.WardModalError.ButtonsDisabled} onClick={props.handleSubmitWardFields} >
                            Confirm
                            { props.wardDetails.WardModalError.IsLoading && <>&ensp;<span className="spinner-border spinner-border-sm" aria-hidden="true"></span></> }                         
                        </button>
                    </div>
                </Modal.Footer>
            </Modal>
        </>
    )
}